module.exports = __webpack_public_path__ + "img/pencil-shadow.68b0f2c.png";